class Tools {
    static preloaderShow() {
        if ($('body').hasClass('desktop')) {
            T.loader();
            $("body").removeClass("fade-in");
        }
    }

    static preloaderHide() {
        if ($('body').hasClass('desktop')) {
            T.removeLoader();
            $("body").addClass("fade-in");
        }
    }
}

export default Tools;
